// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"037bda26","453":"3021cbcf"}[chunkId] + ".chunk.js";
};